module.exports = __webpack_public_path__ + "img/11.08eed832.png";